/* ══════════════════════════════════════
   Super'man London — 메인 JS (완전판 v2)
   Londonjip Ltd | supermanlondon.com
══════════════════════════════════════ */

/* ── 당일배송 마감 카운트다운 (월~토 운영, 일요일 휴무 · 토요일 배송은 2026-09-19부터) ── */
(function initCutoff() {
  var bar = document.getElementById('cutoffBar');
  var msg = document.getElementById('cutoffMsg');
  var pulse = document.getElementById('cutoffPulse');
  var countdown = document.getElementById('cutoffCountdown');
  var heroTimer = document.getElementById('heroCutoff');
  var cartDelivery = document.getElementById('cartDeliveryNote');
  var cartDeliveryText = document.getElementById('cartDeliveryText');

  function pad(n) { return String(n).padStart(2, '0'); }

  function tick() {
    var now = new Date();
    var dow = now.getDay();            // 0=일 1=월 ... 5=금 6=토
    var SAT_FROM = new Date(2026, 8, 19);   // 토요일 배송 시작일
    var isWeekday = (dow >= 1 && dow <= 5) || (dow === 6 && now >= SAT_FROM);
    var before10 = now.getHours() < 10;
    var isOpen = isWeekday && before10; // 지금 주문하면 오늘 받는 상태

    // 다음 배송일 계산 (주말 건너뜀)
    var next = new Date(now);
    if (!isOpen) {
      do { next.setDate(next.getDate() + 1); } while (next.getDay() === 0 || (next.getDay() === 6 && next < SAT_FROM));
    }
    next.setHours(10, 0, 0, 0);

    // 다음 배송일 표현: 내일이면 "내일", 아니면 요일명
    var dayNames = ['일요일','월요일','화요일','수요일','목요일','금요일','토요일'];
    var tomorrow = new Date(now); tomorrow.setDate(tomorrow.getDate() + 1);
    var nextLabel = (next.toDateString() === tomorrow.toDateString()) ? '내일' : dayNames[next.getDay()] + '에';

    if (isOpen) {
      var diff = Math.max(0, next - now);
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var timeStr = (h ? h + ':' : '') + pad(m) + ':' + pad(s);
      if (countdown) countdown.textContent = timeStr + ' 남음';
      if (heroTimer) heroTimer.textContent = timeStr;
      if (bar) bar.className = 'cutoff-bar cutoff-bar--open';
      if (msg) msg.textContent = '당일배송 가능 — 오전 10시 마감, 오늘 받을 수 있어요';
      if (pulse) pulse.style.display = 'block';
      if (cartDelivery && cartDeliveryText) {
        cartDelivery.style.cssText = 'background:#E8F4EC;border:1px solid #7EC89A;border-radius:10px;padding:8px 11px;font-size:10px;color:#1A6B3A;display:flex;align-items:center;gap:6px;margin-bottom:10px';
        cartDeliveryText.textContent = '당일배송 마감: 오전 10:00';
      }
    } else {
      if (countdown) countdown.textContent = '';
      if (heroTimer) heroTimer.textContent = '마감';
      if (bar) bar.className = 'cutoff-bar cutoff-bar--closed';
      var weekend = (dow === 0 || (dow === 6 && now < SAT_FROM));
      if (msg) {
        msg.textContent = weekend
          ? '주말 배송 휴무 — 지금 주문하시면 ' + nextLabel.replace('에','') + ' 배송됩니다 (일요일 휴무)'
          : '오늘 당일배송 마감 — 지금 주문하시면 ' + nextLabel + ' 배송됩니다';
      }
      if (pulse) pulse.style.display = 'none';
      if (cartDelivery && cartDeliveryText) {
        cartDelivery.style.cssText = 'background:#FEF0F0;border:1px solid #F5A0A0;border-radius:10px;padding:8px 11px;font-size:10px;color:#9B2020;display:flex;align-items:center;gap:6px;margin-bottom:10px';
        cartDeliveryText.textContent = '지금 주문 → ' + nextLabel.replace('에','') + ' 배송됩니다';
      }
    }
  }

  tick();
  setInterval(tick, 1000);
})();

/* ── 장바구니 드로어 ── */
function openCartDrawer() {
  document.getElementById('cartOverlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCartDrawer() {
  document.getElementById('cartOverlay').classList.remove('open');
  document.body.style.overflow = '';
}
function closeCartOnOverlay(e) {
  if (e.target === document.getElementById('cartOverlay')) closeCartDrawer();
}

/* Shopify Cart AJAX API */
function addToCart(variantId, title, image, price) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    updateCartCount();
    openCartDrawer();
    refreshCartBody();
  })
  .catch(function(e) { console.error('장바구니 추가 오류:', e); });
}

function removeCartItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    updateCartCount();
    refreshCartBody();
    updateCartTotal(cart.total_price);
  });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var badge = document.getElementById('cartCount');
      if (badge) badge.textContent = cart.item_count;
    });
}

function updateCartTotal(totalCents) {
  var el = document.getElementById('cartTotalPrice');
  if (el) el.textContent = '£' + (totalCents / 100).toFixed(2);
}

function refreshCartBody() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var body = document.getElementById('cartBody');
      if (!body) return;

      updateCartTotal(cart.total_price);
      var badge = document.getElementById('cartCount');
      if (badge) badge.textContent = cart.item_count;

      if (cart.items.length === 0) {
        body.innerHTML = '<div class="cart-empty">장바구니가 비어있어요<br>상품을 담아보세요 🛒</div>';
        return;
      }

      body.innerHTML = cart.items.map(function(item) {
        return '<div class="cart-item" data-key="' + item.key + '">' +
          '<div class="cart-item__emoji">' +
            (item.image
              ? '<img src="' + item.image + '" alt="' + item.title + '" style="width:38px;height:38px;object-fit:cover;border-radius:9px">'
              : '🛒') +
          '</div>' +
          '<div class="cart-item__info">' +
            '<div class="cart-item__name">' + item.title + (item.quantity > 1 ? ' × ' + item.quantity : '') + '</div>' +
            '<div class="cart-item__price">£' + (item.final_line_price / 100).toFixed(2) + '</div>' +
          '</div>' +
          '<button class="cart-item__remove" onclick="removeCartItem(\'' + item.key + '\')">' +
            '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
          '</button>' +
        '</div>';
      }).join('');
    });
}

/* ── 상품 필터 ── */
function setFilter(type) {
  document.querySelectorAll('.filter-tab').forEach(function(tab) {
    tab.className = 'filter-tab';
  });
  var activeTab = document.querySelector('[data-filter="' + type + '"]');
  if (activeTab) activeTab.classList.add('active--' + type);

  var cards = document.querySelectorAll('.product-card');
  var visible = 0;
  cards.forEach(function(card) {
    var same = card.dataset.same === 'true';
    var post = card.dataset.post === 'true';
    var mk = card.dataset.mk === 'true';
    var name = card.dataset.name || '';
    var searchVal = document.getElementById('headerSearch');
    var q = searchVal ? searchVal.value.toLowerCase() : '';

    var typeOk =
      type === 'all' ||
      (type === 'same' && same) ||
      (type === 'post' && post) ||
      (type === 'both' && same && post) ||
      (type === 'mk' && mk);

    var nameOk = !q || name.indexOf(q) > -1;

    if (typeOk && nameOk) {
      card.classList.remove('hidden');
      visible++;
    } else {
      card.classList.add('hidden');
    }
  });

  var countEl = document.getElementById('productCount');
  var labels = { all: '전체', same: '당일배송', post: '택배', both: '둘 다', mk: '밀키트' };
  if (countEl) countEl.textContent = (labels[type] || '전체') + ' ' + visible + '개 상품';
}

/* ══════════════════════════════════════
   음성 주문 — 전체 상품 로컬 매칭 방식 v2
══════════════════════════════════════ */
var voiceResults = [];
var voiceCatalog = null;
var voiceCatalogLoading = false;
var voiceLastTerms = [];

function loadVoiceCatalog_() {
  if (voiceCatalog) return Promise.resolve(voiceCatalog);
  if (voiceCatalogLoading) {
    return new Promise(function(resolve) {
      var t = setInterval(function() {
        if (voiceCatalog) { clearInterval(t); resolve(voiceCatalog); }
      }, 200);
    });
  }
  voiceCatalogLoading = true;

  var all = [];
  function fetchPage(page) {
    return fetch('/products.json?limit=250&page=' + page)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var items = data.products || [];
        items.forEach(function(p) {
          all.push({
            title: p.title,
            titleLower: p.title.toLowerCase(),
            price: p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0,
            variantId: p.variants && p.variants[0] ? p.variants[0].id : null,
            available: p.variants && p.variants[0] ? p.variants[0].available !== false : true,
            img: p.images && p.images[0] ? p.images[0].src : ''
          });
        });
        if (items.length === 250 && page < 8) return fetchPage(page + 1);
      });
  }

  return fetchPage(1).then(function() {
    voiceCatalog = all;
    voiceCatalogLoading = false;
    return voiceCatalog;
  });
}

function openVoiceModal() {
  document.getElementById('voiceOverlay').classList.add('open');
  document.getElementById('voiceResults').classList.remove('show');
  document.getElementById('voiceText').textContent = '말씀해주세요...';
  document.getElementById('voiceHint').textContent = '아래 예시를 눌러보거나 원하는 상품을 말해보세요';
  document.body.style.overflow = 'hidden';

  loadVoiceCatalog_();

  if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
    startSpeechRecognition();
  }
}

function closeVoiceModal() {
  document.getElementById('voiceOverlay').classList.remove('open');
  document.body.style.overflow = '';
}

function closeVoiceOnOverlay(e) {
  if (e.target === document.getElementById('voiceOverlay')) closeVoiceModal();
}

function startSpeechRecognition() {
  var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) return;

  var recognition = new SR();
  recognition.lang = 'ko-KR';
  recognition.interimResults = false;
  recognition.maxAlternatives = 1;

  document.getElementById('voiceResults').classList.remove('show');
  document.getElementById('voiceText').textContent = '듣고 있어요...';
  document.getElementById('voiceHint').textContent = '원하는 상품을 말해보세요';

  recognition.onresult = function(event) {
    var transcript = event.results[0][0].transcript;
    document.getElementById('voiceText').textContent = '"' + transcript + '"';
    document.getElementById('voiceHint').textContent = '인식 완료 — 상품 찾는 중...';
    setTimeout(function() { voiceSearch(transcript); }, 300);
  };

  recognition.onerror = function() {
    document.getElementById('voiceText').textContent = '인식 실패 — 다시 말하기를 누르거나 예시를 눌러보세요';
  };

  recognition.start();
}

/* 🎤 다시 말하기 버튼 */
function voiceRetry() {
  if ('webkitSpeechRecognition' in window || 'SpeechRecognition' in window) {
    startSpeechRecognition();
  } else {
    document.getElementById('voiceText').textContent = '이 브라우저는 음성 인식을 지원하지 않아요';
  }
}

function simulateVoice(text) {
  document.getElementById('voiceText').textContent = '"' + text + '"';
  document.getElementById('voiceHint').textContent = '인식 완료 — 상품 찾는 중...';
  setTimeout(function() { voiceSearch(text); }, 300);
}

function cleanVoiceQuery_(text) {
  return text
    .replace(/[.,!?~·。、]/g, ' ')
    .replace(/주세요|주문할게요|주문할게|주문해줘|담아줘|담아 줘|담아주세요|추천해줘|추천해 줘|추천|보여줘|보여 줘|찾아줘|찾아 줘|해줘|해 줘|줘요|줘|좀|요$/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function splitVoiceTerms_(text) {
  return text
    .split(/\+|,|하고|랑|이랑|그리고|과 |와 /)
    .map(function(t) { return t.trim(); })
    .filter(function(t) { return t.length >= 1; });
}

function scoreMatch_(titleLower, term) {
  var idx = titleLower.indexOf(term);
  if (idx === -1) return 0;
  var score = 100;
  if (idx === 0) score += 30;
  score -= Math.min(idx, 20);
  score += Math.max(0, 30 - titleLower.length / 2);
  return score;
}

function collectMatches_(catalog, terms) {
  var seen = {};
  var all = [];
  terms.forEach(function(term) {
    var termLower = term.toLowerCase();
    var matches = [];
    catalog.forEach(function(p) {
      if (!p.available || !p.variantId) return;
      var score = scoreMatch_(p.titleLower, termLower);
      if (score > 0) matches.push({ p: p, score: score });
    });
    matches.sort(function(a, b) { return b.score - a.score; });
    matches.forEach(function(m) {
      if (!seen[m.p.variantId]) {
        seen[m.p.variantId] = true;
        all.push({
          name: m.p.title,
          price: '£' + m.p.price.toFixed(2),
          img: m.p.img,
          variantId: m.p.variantId
        });
      }
    });
  });
  return all;
}

function voiceSearch(text) {
  var cleaned = cleanVoiceQuery_(text);
  var lower = cleaned.toLowerCase();

  if (lower.indexOf('당일') > -1 || lower.indexOf('전체') > -1 || lower.indexOf('전부') > -1) {
    var cards = document.querySelectorAll('.product-card');
    var found = [];
    cards.forEach(function(card) {
      if (card.dataset.same === 'true' && found.length < 4) {
        var nameEl = card.querySelector('.product-card__name');
        var priceEl = card.querySelector('.product-card__price');
        var imgEl = card.querySelector('.product-card__img img');
        var addBtn = card.querySelector('.product-card__add');
        var vid = addBtn ? (addBtn.getAttribute('onclick') || '').match(/\d+/) : null;
        found.push({
          name: nameEl ? nameEl.textContent : '',
          price: priceEl ? priceEl.textContent : '',
          img: imgEl ? imgEl.src : '',
          variantId: vid ? parseInt(vid[0]) : null
        });
      }
    });
    renderVoiceResults_(found);
    return;
  }

  var terms = splitVoiceTerms_(cleaned);
  if (!terms.length) terms = [cleaned];
  voiceLastTerms = terms;

  loadVoiceCatalog_().then(function(catalog) {
    if (!catalog || !catalog.length) {
      document.getElementById('voiceText').textContent = '상품 목록을 불러오지 못했어요';
      document.getElementById('voiceHint').textContent = '잠시 후 다시 시도해주세요';
      return;
    }

    var allMatches = collectMatches_(catalog, terms);

    if (!allMatches.length) {
      document.getElementById('voiceText').textContent = '"' + cleaned + '" 상품을 찾지 못했어요 😅';
      document.getElementById('voiceHint').textContent = '다시 말하기를 누르거나 다른 이름으로 말해보세요';
      return;
    }

    var shown = allMatches.slice(0, 12);
    renderVoiceResults_(shown);

    if (allMatches.length > shown.length) {
      document.getElementById('voiceText').textContent =
        '🎉 총 ' + allMatches.length + '개 중 ' + shown.length + '개를 보여드려요';
      var row = document.getElementById('voiceResultsRow');
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.setAttribute('style',
        'display:flex;flex-direction:column;align-items:center;justify-content:center;' +
        'min-width:100px;flex-shrink:0;padding:14px 10px;background:#EDF2FB;border:1px dashed #1B4FBE;' +
        'border-radius:10px;color:#1B4FBE;font-size:12.5px;font-weight:600;text-align:center;' +
        'cursor:pointer;pointer-events:auto;position:relative;z-index:10;');
      moreBtn.innerHTML = '나머지 ' + (allMatches.length - shown.length) + '개<br>더 보기 +';
      moreBtn.addEventListener('click', function(ev) {
        ev.stopPropagation();
        renderVoiceResults_(allMatches);
        document.getElementById('voiceText').textContent = '🎉 전체 ' + allMatches.length + '개 상품이에요';
      });
      row.appendChild(moreBtn);
    } else {
      document.getElementById('voiceText').textContent = '🎉 ' + shown.length + '개 상품을 찾았어요';
    }
  });
}

function renderVoiceResults_(found) {
  voiceResults = found;

  if (!found.length) {
    document.getElementById('voiceText').textContent = '상품을 찾지 못했어요 😅';
    document.getElementById('voiceHint').textContent = '다시 말하기를 누르거나 다른 이름으로 말해보세요';
    return;
  }

  document.getElementById('voiceText').textContent = '🎉 ' + found.length + '개 상품을 찾았어요';
  document.getElementById('voiceHint').textContent = '상품을 눌러 선택하세요 (여러 개 가능)';

  var row = document.getElementById('voiceResultsRow');
  row.innerHTML = '';

  found.forEach(function(p, i) {
    var card = document.createElement('div');
    card.className = 'voice-product';
    card.setAttribute('data-idx', i);
    card.style.cssText = 'cursor:pointer;position:relative;border:2px solid transparent;border-radius:10px;transition:border-color .15s;';
    card.innerHTML =
      '<div class="voice-product__check" style="display:none;position:absolute;top:6px;right:6px;width:20px;height:20px;background:#1B4FBE;border-radius:50%;color:#fff;font-size:12px;line-height:20px;text-align:center;z-index:5;">✓</div>' +
      '<div class="voice-product__img">' +
        (p.img ? '<img src="' + p.img + '" alt="' + p.name + '" style="width:100%;height:100%;object-fit:cover">' : '🛒') +
      '</div>' +
      '<div class="voice-product__body">' +
        '<div class="voice-product__name">' + p.name + '</div>' +
        '<div class="voice-product__price">' + p.price + '</div>' +
      '</div>';

    card.addEventListener('click', function() {
      p.selected = !p.selected;
      card.style.borderColor = p.selected ? '#1B4FBE' : 'transparent';
      card.querySelector('.voice-product__check').style.display = p.selected ? 'block' : 'none';
      updateVoiceAddBtn_();
    });

    row.appendChild(card);
  });

  document.getElementById('voiceResults').classList.add('show');
  updateVoiceAddBtn_();
  document.getElementById('voiceAddAll').onclick = function() {
    voiceAddAll();
  };
}

/* 담기 버튼 라벨 갱신 */
function updateVoiceAddBtn_() {
  var btn = document.getElementById('voiceAddAll');
  if (!btn) return;
  var selected = voiceResults.filter(function(p) { return p.selected; });
  btn.textContent = selected.length > 0
    ? '선택한 ' + selected.length + '개 담기 🛒'
    : '모두 담기 🛒 (' + voiceResults.length + '개)';
}

function voiceAddAll() {
  var selected = voiceResults.filter(function(p) { return p.selected; });
  var toAdd = selected.length > 0 ? selected : voiceResults;

  var promises = toAdd.map(function(p) {
    if (p.variantId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: p.variantId, quantity: 1 })
      }).then(function(r) { return r.json(); });
    }
    return Promise.resolve();
  });

  Promise.all(promises).then(function() {
    closeVoiceModal();
    updateCartCount();
    refreshCartBody();
    openCartDrawer();
  });
}

/* ── 초기화 ── */
document.addEventListener('DOMContentLoaded', function() {
  updateCartCount();
});